import React from 'react';
import { formatNameWithInitials } from '../helpers/constants';

export default function CommentTree({ comments, onReplyClick, canReply }) {
  if (!comments || comments.length === 0) {
    return <p className="comments-empty">Ainda não tem comentários.</p>;
  }

  return (
    <ul className="comments-list">
      {comments.map((c) => (
        <li key={c.id} className="comment-item">
          <div className="comment-bubble">
            <div className="comment-header">
              <span className="comment-author">
                {c.userName ? formatNameWithInitials(c.userName) : 'Anônimo'}
              </span>
              {canReply && (
                <button
                  type="button"
                  className="comment-reply-btn"
                  onClick={() => onReplyClick(c)}
                >
                  Responder
                </button>
              )}
            </div>
            <p className="comment-text">{c.text}</p>
          </div>

          {c.replies && c.replies.length > 0 && (
            <ul className="comments-list replies">
              {c.replies.map((r) => (
                <li key={r.id} className="comment-item">
                  <div className="comment-bubble reply">
                    <div className="comment-header">
                      <span className="comment-author">
                        {r.userName ? formatNameWithInitials(r.userName) : 'Anônimo'}
                      </span>
                    </div>
                    <p className="comment-text">{r.text}</p>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </ul>
  );
}
